import { useRoutingContext } from "../../context/context/RoutingContext.js";
function useLocation() {
  const { router } = useRoutingContext();
  return {
    push: router.push,
    replace: router.replace,
    pathname: router.pathname,
    query: router.query
  };
}
export {
  useLocation
};
//# sourceMappingURL=use-location.js.map
